<template>
  <div class='wrapper' v-if="isshow">
    <div class='loading'>
      <div>
        <img src="/eosrent/images/loading-1.gif" alt="">
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>

</style>

<script>
export default {
  props: {
    duartion: {
      type: String,
      default: '1s'
    },
    isshow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  mixins: [],
  components: {},
  mounted () {

  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/loading/loading.vue